var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex",
    { staticClass: "statistics-list", attrs: { justify: "around" } },
    _vm._l(_vm.statisticsList, function(item) {
      return _c(
        "flex",
        {
          key: item.id,
          staticClass: "statistics-item",
          attrs: { direction: "column", align: "center", justify: "center" }
        },
        [
          _c("span", { staticClass: "count" }, [_vm._v(_vm._s(item.value))]),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.statisticsName(item.id)))
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }